<template>
	<span>{{title}}</span>
</template>
<script>
import EventModel from '@/models/event.js'

export default {
	props: ['uuid'],
	data() {
    var ch = this.$cloudserver.channel("events:"+this.uuid);
		return {
			ws_channel: ch,
			event: ch.data
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				this.event = newVal;
			},
			deep: true
		}
	},
	computed: {
		title() {
			return EventModel.title(this.event);
		}
	},
	mounted () {
		if(this.ws_channel) this.ws_channel.join();
	}
}
</script>